import {KeyboardShortcut} from './KeyboardShortcut';

export type KeyboardShortcutDefinition = {
  matches: (event: KeyboardEvent) => boolean;
  labelMac: string;
  labelOther: string;
  ariaKeyShortcuts: string;
};

const isModOnly = (event: KeyboardEvent) =>
  (event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey;

export const KEYBOARD_SHORTCUT_DEFINITIONS: Record<KeyboardShortcut, KeyboardShortcutDefinition> = {
  [KeyboardShortcut.ModS]: {
    matches: (event) => isModOnly(event) && event.key.toLowerCase() === 's',
    labelMac: '⌘S',
    labelOther: 'Ctrl+S',
    ariaKeyShortcuts: 'Control+s Meta+s',
  },
  [KeyboardShortcut.ModEnter]: {
    matches: (event) => isModOnly(event) && event.key.toLowerCase() === 'enter',
    labelMac: '⌘Enter',
    labelOther: 'Ctrl+Enter',
    ariaKeyShortcuts: 'Control+Enter Meta+Enter',
  },
};
